import React from "react";

import {MuiIcon, MuiIconExternalProps} from "../MuiIcon";

export const ItalicIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\ue23f'}</MuiIcon>
        );
    })